export const formatAvailabilityId = (availabilityId: string, format = 'HH:mm') => {
  return availabilityId.slice(0, 19)
}
